import { TasksTabs } from 'pages/TaskTemplates/DragComponents/Tasks.styled'
import styled from 'styled-components'

export const DropDownTab = styled(TasksTabs)`
  position: relative;
  @media (max-width: 1300px) {
    margin-bottom: 1rem;
  }
`

interface IDropDownOptionTabs {
  showDropDown: boolean
}

export const DropDownOptionTabs = styled.div<IDropDownOptionTabs>`
  position: absolute;
  top: 110%;
  left: 50%;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  padding: 10px;
  transition: 0.2s ease;
  transform-origin: top;

  ${(props) => props.theme.container};
  ${(props) =>
    props.showDropDown
      ? 'opacity:1; { transform: scaleY(1)  translateX(-50%)}'
      : 'opacity:0; { transform: scaleY(0)  translateX(-50%)}'}

  @media (max-width: 1300px) {
    width: 100%;
  }
`
